import { HTTP_Pagination_Response } from '@api-new/common';
import { HTTP_CP_SmartSearch } from '@api-new/mortgageservice';
import { Dictionary } from '@ngrx/entity';
import { createFeatureSelector, createSelector } from '@ngrx/store';
import { smartSearchesAdapter } from '@shared/store/smart-searches/smart-searches.reducer';
import { SmartSearchesState } from '@shared/store/smart-searches/smart-searches.state';

const { selectAll, selectEntities } = smartSearchesAdapter.getSelectors();

export const selectSmartSearchesState = createFeatureSelector<SmartSearchesState>('smartSearches');

export const selectSmartSearches = createSelector(selectSmartSearchesState, (smartSearchesState: SmartSearchesState) =>
  selectAll(smartSearchesState),
);

export const selectSmartSearchesEntities = createSelector(selectSmartSearchesState, (smartSearchesState: SmartSearchesState) =>
  selectEntities(smartSearchesState),
);

export const selectSmartSearch = (smartSearchId: string) =>
  createSelector(selectSmartSearchesEntities, (smartSearchEntities: Dictionary<HTTP_CP_SmartSearch>) => smartSearchEntities[smartSearchId]);

export const selectIsLoadingSmartSearches = createSelector(
  selectSmartSearchesState,
  (smartSearchesState: SmartSearchesState) => smartSearchesState.loading,
);

export const selectSmartSearchesPagination = createSelector(
  selectSmartSearchesState,
  (smartSearchesState: SmartSearchesState): HTTP_Pagination_Response => smartSearchesState.pagination,
);
